import { useEffect, useState } from 'react'

import { cameraLiveCircuit } from '@/lib/camera-live-circuit'

interface CameraCircuitAutoStartInput {
    autoStart: boolean
    vehicleId: string
    cameraId: number
    retryAt?: number
    start: () => void | Promise<void>
}

export function useCameraCircuitAutoStart({
    autoStart,
    vehicleId,
    cameraId,
    retryAt,
    start,
}: CameraCircuitAutoStartInput) {
    const [circuitRevision, setCircuitRevision] = useState(0)

    useEffect(() => {
        if (!autoStart || cameraLiveCircuit.shouldSkip(vehicleId)) return
        void start()
    }, [autoStart, vehicleId, cameraId, start, circuitRevision])

    useEffect(() => {
        if (!autoStart || retryAt === undefined) return
        const timeout = window.setTimeout(
            () => setCircuitRevision((current) => current + 1),
            Math.max(0, retryAt - Date.now()),
        )
        return () => window.clearTimeout(timeout)
    }, [autoStart, vehicleId, cameraId, retryAt])
}
